<template>
    <div>
        <div class="w-full flex flex-col justify-center items-center">
            <ImageGrid v-if="this.$parent.getImages()" :images="this.$parent.getImages()"></ImageGrid>
        </div>
    </div>
</template>

<script>
    import ImageGrid from "./ImageGrid"

    export default {
        name: "CasesComponent",
        components: {ImageGrid}
    }
</script>

<style scoped>
    #bg-front {
        filter: contrast(80%);
        height: 12rem;
        background-size: 100%;
        background: url("https://images.pexels.com/photos/942316/pexels-photo-942316.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260") no-repeat 0;
    }
</style>
